import logger from '%app/js/common/services/Logger';

const listeners = new Set();

const subscribeToPostHogReady = (listener) => {
    listeners.add(listener);

    return () => {
        listeners.delete(listener);
    };
};

const notifyPostHogReady = () => {
    Array.from(listeners).forEach((listener) => {
        try {
            listener();
        } catch (error) {
            logger.warning('postHogReadyNotifier: listener failed', { error });
        }
    });
};

export { subscribeToPostHogReady, notifyPostHogReady };
